import {
  TEXT_EDITOR_DEFAULT_PAGE_LAYOUT_MODE,
  TEXT_EDITOR_DEFAULT_PRINT_PAGE_NUMBERS_ENABLED,
  TEXT_EDITOR_PAGE_LAYOUT_MODE,
  TEXT_EDITOR_PAGE_ORIENTATION,
  normalizeTextEditorPageLayoutMode,
} from './textEditorPageLayout';
import { normalizeTextEditorPageOrientation } from './textEditorPageOrientation';
import {
  TEXT_EDITOR_DEFAULT_CUSTOM_PRINT_MARGINS_IN,
  TEXT_EDITOR_DEFAULT_PRINT_MARGIN_PRESET,
  normalizeCustomPrintMarginsIn,
  normalizePrintMarginPreset,
} from './textEditorPrintLayout';

const SETTINGS_COMMENT_RE =
  /^\s*<!--\s*wfm-document-page-settings:v1:([\s\S]*?)\s*-->\s*/i;

export function normalizeDocumentPageSettings(input) {
  const src = input && typeof input === 'object' ? input : {};
  return {
    pageOrientation: normalizeTextEditorPageOrientation(src.pageOrientation),
    pageLayoutMode: normalizeTextEditorPageLayoutMode(src.pageLayoutMode),
    printMarginPreset: normalizePrintMarginPreset(src.printMarginPreset),
    customPrintMarginsIn: normalizeCustomPrintMarginsIn(
      src.customPrintMarginsIn || TEXT_EDITOR_DEFAULT_CUSTOM_PRINT_MARGINS_IN
    ),
    printPageNumbersEnabled:
      src.printPageNumbersEnabled === false
        ? false
        : TEXT_EDITOR_DEFAULT_PRINT_PAGE_NUMBERS_ENABLED,
  };
}

export function getDefaultDocumentPageSettings() {
  return normalizeDocumentPageSettings({
    pageOrientation: TEXT_EDITOR_PAGE_ORIENTATION.PORTRAIT,
    pageLayoutMode: TEXT_EDITOR_DEFAULT_PAGE_LAYOUT_MODE,
    printMarginPreset: TEXT_EDITOR_DEFAULT_PRINT_MARGIN_PRESET,
    customPrintMarginsIn: TEXT_EDITOR_DEFAULT_CUSTOM_PRINT_MARGINS_IN,
    printPageNumbersEnabled: TEXT_EDITOR_DEFAULT_PRINT_PAGE_NUMBERS_ENABLED,
  });
}

export function parseDocumentPageSettingsFromHtml(html) {
  const raw = String(html || '');
  const match = raw.match(SETTINGS_COMMENT_RE);
  if (!match) {
    return { bodyHtml: raw, documentPageSettings: null };
  }
  try {
    const json = decodeURIComponent(match[1].trim());
    const parsed = JSON.parse(json);
    const bodyHtml = raw.slice(match[0].length);
    return {
      bodyHtml,
      documentPageSettings: normalizeDocumentPageSettings(parsed),
    };
  } catch {
    return { bodyHtml: raw, documentPageSettings: null };
  }
}

export function wrapHtmlWithDocumentPageSettings(bodyHtml, settings) {
  const body = String(bodyHtml || '');
  const normalized = settings ? normalizeDocumentPageSettings(settings) : null;
  if (!normalized) return body;
  const json = encodeURIComponent(JSON.stringify(normalized));
  return `<!-- wfm-document-page-settings:v1:${json} -->\n${body}`;
}

/** Strip settings comment for display/export if raw file text is passed. */
export function stripDocumentPageSettingsComment(html) {
  return parseDocumentPageSettingsFromHtml(html).bodyHtml;
}
